<div class="d-flex flex-column gap-3" data-testid="credit-note-table-panel">
  <h3 class="av-section-title m-0">{{ 'backoffice.billing.credit_notes.title' | translate }}</h3>

  @switch (facade.creditNotesState()) {
    @case ('restricted') {
      <av-empty-state
        icon="lock"
        [title]="'backoffice.billing.credit_notes.restricted_title' | translate"
        [message]="'backoffice.billing.documents.money_out_restricted' | translate"
      ></av-empty-state>
    }
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.billing.credit_notes.error_title' | translate"
        [message]="'backoffice.billing.credit_notes.error_message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      @if (isEmpty()) {
        <av-empty-state
          icon="receipt"
          [title]="'backoffice.billing.credit_notes.empty_title' | translate"
          [message]="'backoffice.billing.credit_notes.empty_message' | translate"
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100" data-testid="credit-note-table">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.billing.credit_notes.table.credit_note' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.credit_notes.table.status' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.credit_notes.table.amount' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.credit_notes.table.reason' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.credit_notes.table.cash_refund' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.credit_notes.table.created' | translate }}</th>
                <th scope="col"></th>
              </tr>
            </thead>

            <tbody>
              @for (creditNote of facade.creditNotes(); track creditNote.id) {
                <tr>
                  <td class="av-source">{{ creditNote.stripe_credit_note_id || unresolved }}</td>

                  <td>
                    <av-status-chip
                      [label]="creditNote.statusLabelKey | translate"
                      [tone]="creditNote.statusTone"
                    ></av-status-chip>
                  </td>

                  <td class="text-end">
                    {{ creditNote.amount | number: '1.2-2' }} {{ creditNote.currency || '' }}
                  </td>

                  <td class="cell-muted">
                    {{ reasonLabel(creditNote.reason) | translate }}
                  </td>

                  <td class="cell-muted">{{ (creditNote.refunded ? 'backoffice.common.yes' : 'backoffice.common.no') | translate }}</td>

                  <td class="cell-muted">
                    {{
                      creditNote.created_at
                        ? (creditNote.created_at | date: dateTimeFormat)
                        : unresolved
                    }}
                  </td>

                  <td>
                    <a
                      class="av-btn text-decoration-none"
                      [routerLink]="[
                        '/organizations',
                        facade.organizationId(),
                        'billing',
                        'invoices',
                        creditNote.invoice_id,
                      ]"
                      data-testid="credit-note-invoice-link"
                    >
                      {{ 'backoffice.billing.credit_notes.invoice_link' | translate }}
                    </a>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.creditNotePage()"
          [pageSize]="facade.pageSize()"
          [total]="facade.creditNoteTotal()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.billing.credit_notes.loading_title' | translate"
        [message]="'backoffice.billing.credit_notes.loading_message' | translate"
      ></av-empty-state>
    }
  }
</div>
